import { useEffect } from 'react';
import { signOut } from 'util/auth';

export default function AccountDeletedCallbackScreens() {
  useEffect(() => {
    signOut();
  }, []);

  return <></>;
}
